__turbopack_context__.v({
  "controls": "ro1Rrq_controls",
  "form": "ro1Rrq_form",
  "input": "ro1Rrq_input",
  "mktuClass": "ro1Rrq_mktuClass",
  "mktuClassButton": "ro1Rrq_mktuClassButton",
  "selectedClasses": "ro1Rrq_selectedClasses",
  "settingsBtn": "ro1Rrq_settingsBtn",
  "settingsBtnIcon": "ro1Rrq_settingsBtnIcon",
  "submitButton": "ro1Rrq_submitButton",
  "title": "ro1Rrq_title",
});
